"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placedPartDbIdFromModuleRef = placedPartDbIdFromModuleRef;
function placedPartDbIdFromModuleRef(moduleRef) {
    if (moduleRef.includes('::schref::')) {
        return undefined;
    }
    const match = /::(\d+)$/.exec(moduleRef);
    if (!match) {
        return undefined;
    }
    const parsed = Number.parseInt(match[1], 10);
    return Number.isNaN(parsed) ? undefined : parsed;
}
//# sourceMappingURL=orcadModuleRef.js.map